import { render, staticRenderFns } from "./SeverityTableCell.vue?vue&type=template&id=173dafa7&scoped=true"
import script from "./SeverityTableCell.vue?vue&type=script&lang=js"
export * from "./SeverityTableCell.vue?vue&type=script&lang=js"
import style0 from "./SeverityTableCell.vue?vue&type=style&index=0&id=173dafa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173dafa7",
  null
  
)

export default component.exports